import React, { useEffect, useState } from "react";
import { getManifestEvents } from "@/lib/api";
import { CaretDown, LockSimple, LockOpen } from "@phosphor-icons/react";

export default function LockHistory({ storyId, refreshKey }) {
  const [open, setOpen] = useState(false);
  const [events, setEvents] = useState([]);

  useEffect(() => {
    getManifestEvents(storyId).then(setEvents).catch(() => setEvents([]));
  }, [storyId, refreshKey]);

  if (events.length === 0) return null;

  return (
    <div data-testid="lock-history-panel">
      <button
        data-testid="lock-history-toggle-btn"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-1 text-[11px] text-slate-500 hover:text-slate-300 transition-colors"
      >
        <CaretDown size={10} className={`transition-transform ${open ? "rotate-180" : ""}`} />
        Lock history ({events.length})
      </button>
      {open && (
        <ul className="mt-1 space-y-1 border-l border-slate-800 pl-3">
          {events.map((e) => (
            <li key={e.id} className="text-[11px] text-slate-500 flex items-start gap-1.5">
              {e.action === "locked" ? (
                <LockSimple size={10} className="text-emerald-500 mt-0.5 shrink-0" />
              ) : (
                <LockOpen size={10} className="text-amber-500 mt-0.5 shrink-0" />
              )}
              <span>
                <span className="uppercase font-mono">{e.action}</span> — {new Date(e.created_at).toLocaleString()}
                {e.note && <span className="italic"> · {e.note}</span>}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
